import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 查看 ")

import { PropType } from "vue";
import SubmitApprovalBtn from "./submit-approval-btn.vue";
import AgreeBtn from "./agree-btn.vue";
import RejectBtn from "./reject-btn.vue";
import CancelBtn from "./calcel-btn.vue";
import VoidBtn from "./void-btn.vue";
import LostOrderBtn from "./lost-order-btn.vue";


import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "ShowButton",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  bizType: {
    type: String,
    default: "",
  },
  record: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  bizId: {
    type: String,
    default: "",
  },
  bizName: {
    type: String,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  examineAccess: {
    type: String,
  },
  showLostOrderBtn: {
    type: Boolean,
    default: false,
  },
  showVoidBtn: {
    type: Boolean,
    defalut: false,
  },
  showCancelBtn: {
    type: Boolean,
    default: false,
  },
  existRelation: {
    type: Boolean,
    default: false,
  },
  showRejectBtn: {
    type: Boolean,
    default: false,
  },
  showAgreeBtn: {
    type: Boolean,
    default: false,
  },
  showSubmitBtn: {
    type: Boolean,
    default: false,
  },
  path: {
    type: String,
    default: "",
  },
  viewPath: {
    type: String,
    default: "",
  },
  showEditFlg: {
    type: Boolean,
    default: false,
  },
},
  emits: ["refreshApprovalDetail"],
  setup(__props, { emit }) {

const props = __props





function refreshApprovalDetail() {
  emit("refreshApprovalDetail");
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showEditFlg)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: __props.path,
          class: "table-btn"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (__props.record.status !== 'ygb' && __props.bizType === 'project_examine')
      ? (_openBlock(), _createBlock(SubmitApprovalBtn, {
          key: 1,
          loading: __props.loading,
          onRefresh: refreshApprovalDetail,
          "biz-type": __props.bizType,
          "biz-id": __props.bizId,
          "biz-name": __props.bizName,
          flg: __props.showSubmitBtn,
          access: __props.examineAccess,
          class: "table-btn"
        }, null, 8, ["loading", "biz-type", "biz-id", "biz-name", "flg", "access"]))
      : (__props.bizType !== 'project_examine')
        ? (_openBlock(), _createBlock(SubmitApprovalBtn, {
            key: 2,
            loading: __props.loading,
            onRefresh: refreshApprovalDetail,
            className: "table-btn",
            "biz-type": __props.bizType,
            "biz-id": __props.bizId,
            "biz-name": __props.bizName,
            flg: __props.showSubmitBtn,
            access: __props.examineAccess
          }, null, 8, ["loading", "biz-type", "biz-id", "biz-name", "flg", "access"]))
        : _createCommentVNode("", true),
    _createVNode(AgreeBtn, {
      loading: __props.loading,
      onRefresh: refreshApprovalDetail,
      className: "table-btn",
      "biz-type": __props.bizType,
      "biz-id": __props.bizId,
      flg: __props.showAgreeBtn,
      access: __props.examineAccess
    }, null, 8, ["loading", "biz-type", "biz-id", "flg", "access"]),
    _createVNode(RejectBtn, {
      loading: __props.loading,
      onRefresh: refreshApprovalDetail,
      className: "table-btn",
      "biz-type": __props.bizType,
      "biz-id": __props.bizId,
      flg: __props.showRejectBtn,
      access: __props.examineAccess
    }, null, 8, ["loading", "biz-type", "biz-id", "flg", "access"]),
    _createVNode(CancelBtn, {
      loading: __props.loading,
      onRefresh: refreshApprovalDetail,
      className: "table-btn",
      "biz-type": __props.bizType,
      "biz-id": __props.bizId,
      flg: __props.showCancelBtn,
      access: __props.examineAccess
    }, null, 8, ["loading", "biz-type", "biz-id", "flg", "access"]),
    _createVNode(VoidBtn, {
      loading: __props.loading,
      className: "table-btn",
      onRefresh: refreshApprovalDetail,
      "biz-type": __props.bizType,
      "biz-id": __props.bizId,
      "biz-name": __props.bizName,
      flg: __props.showVoidBtn && !__props.existRelation,
      access: __props.examineAccess
    }, null, 8, ["loading", "biz-type", "biz-id", "biz-name", "flg", "access"]),
    (__props.showLostOrderBtn && __props.record.status !== 'ygb' && __props.bizType === 'project_examine')
      ? (_openBlock(), _createBlock(LostOrderBtn, {
          key: 3,
          className: "table-btn",
          "biz-id": __props.bizId,
          "biz-type": __props.bizType,
          "biz-name": __props.bizName,
          loading: __props.loading,
          onRefresh: refreshApprovalDetail,
          access: __props.examineAccess
        }, null, 8, ["biz-id", "biz-type", "biz-name", "loading", "access"]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_link, {
      to: __props.viewPath,
      class: "table-btn"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["to"])
  ], 64))
}
}

})